// extracted by mini-css-extract-plugin
export default {"reasons":"ModalReasonCreate_reasons__Wbqja","reason__label":"ModalReasonCreate_reason__label__wUR5X"};